import { useTranslation } from 'react-i18next'

import { validateJSON } from '@/common/utils/validateJSON'
import { z } from '@/lib/zod'

export function ManageAuthCreateSchema() {
  const { t } = useTranslation('sso')

  return z.object({
    clientKey: z.string().min(1),
    password: z.string().min(1),
    headers: z.string().refine(
      (val) => {
        if (!val || val.trim() === '') return true
        return validateJSON(val)
      },
      {
        message: t(
          'applications.drawer_manage_auth.schema.headers.invalid_json',
        ),
      },
    ),
  })
}

export function ManageAuthUpdateSchema() {
  const { t } = useTranslation('sso')

  return z.object({
    headers: z.string().refine(
      (val) => {
        if (!val || val.trim() === '') return true
        return validateJSON(val)
      },
      {
        message: t(
          'applications.drawer_manage_auth.schema.headers.invalid_json',
        ),
      },
    ),
  })
}

export type ManageAuthCreateForm = z.infer<
  ReturnType<typeof ManageAuthCreateSchema>
>
export type ManageAuthUpdateForm = z.infer<
  ReturnType<typeof ManageAuthUpdateSchema>
>
export type ManageAuthForm = ManageAuthCreateForm | ManageAuthUpdateForm
